import { getShopRendererApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class ShopRendererOfferApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getOffers = (pathParams, queryParams) => {
            return this.get(`/shops/${pathParams.shop_id}/offers`, queryParams);
        };
        this.getOffer = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/offers/${pathParams.offer_id}`);
        };
        this.getCollections = (pathParams, queryParams) => {
            return this.get(`/shops/${pathParams.shop_id}/offers_collections`, queryParams);
        };
        this.getCollection = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/offers_collections/${pathParams.id}`);
        };
    }
}
export const ShopRendererOfferApiClient = new ShopRendererOfferApiClientModel(getShopRendererApiUrl('api'));
